<template>
  <div>
    <el-row v-show="showHisFilters">
      <!--查询条件表单-->
      <el-form :model="searchHisForm" ref="searchHisFormRef" size="mini" :inline="true">
        <el-col :span="3">
          <el-form-item prop="operatorId">
<!--            <el-select placeholder="运营商" v-model="searchHisForm.operatorId"  clearable>
              <el-option v-for="item in operatorForSelect" :key="item.id"
                         v-bind:label="item.name" v-bind:value="item.id"></el-option>
            </el-select>-->
            <el-cascader  size="mini" clearable ref="cascader"
                          :placeholder="$t('deviceControl.operatorId')"  filterable
                          :options="operatorTree"
                          :props="{ checkStrictly:true,expandTrigger:'hover'}"
                          :show-all-levels="false"
                          change-on-select
                          @change='handleChangeOperator'
                          v-model="searchHisForm.operatorId">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="ruleName">
            <el-input :placeholder="$t('gui-dang-fei-shuai-ming-cheng')" v-model="searchHisForm.ruleName"  clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="resetSearchHisttoryForm">{{ $t('deviceControl.empty') }}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="searchHisLoading" @click="submitSearchHisForm">{{ $t('deviceControl.search') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <el-table :data="rateHisDataTable" stripe style="width: 100%" ref="rateHisDataTable" border
              v-loading="listHisLoading">
      <af-table-column prop="backupRateId" :label="$t('yuan-shi-fei-shuai-mo-xing-id')"></af-table-column>
      <af-table-column prop="id" :label="$t('gui-dang-fei-shuai-mo-xing-id')"></af-table-column>
      <af-table-column prop="ruleName" :label="$t('gui-dang-fei-shuai-ming-cheng-0')"></af-table-column>
      <af-table-column prop="operatorName" :label="$t('suo-shu-yun-ying-shang-0')"></af-table-column>
      <af-table-column width="200" :label="$t('siteMonitor.ElectricityBill')">
        <template slot-scope="scope">
          <div v-if="scope.row.typeCode === 'standard' && scope.row.pileType == 'Q' ">
            <span style="color: #2fff00;" class="span_one">{{ $t('key') }}</span><span
            v-html="$t('chang-gui-dian-fei')+' : ' + scope.row.standardElectricityFees + $t('yuan-kw')"></span>
          </div>
          <div v-else-if="scope.row.typeCode === 'times'">
            <span style="color: #ff4d4d;" class="span_one">{{ $t('key') }}</span><span
            v-html=" (scope.row.pileType == 'Q'?$t('jian-dian-fei')+' : ':$t('di-yi-jie-duan-gong-lv')) + scope.row.topElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
            <span style="color:  #ffbc2e " class="span_one">{{ $t('key') }}</span><span
            v-html=" (scope.row.pileType == 'Q'?$t('feng-dian-fei')+' : ':$t('di-er-jie-duan-gong-lv')) + scope.row.summitElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
            <span style="color: #43c26e" class="span_one">{{ $t('key') }}</span><span
            v-html=" (scope.row.pileType == 'Q'?$t('ping-dian-fei')+' : ':$t('di-san-jie-duan-gong-lv')) + scope.row.flatElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
            <span style="color: #409EFF" class="span_one">{{ $t('key') }}</span><span
            v-html=" (scope.row.pileType == 'Q'?$t('gu-dian-fei')+' : ':$t('wang-hou-jie-duan-gong-lv')) + scope.row.valleyElectricityFees + (scope.row.pileType == 'Q'?$t('yuan-kw'):'W')"></span><br/>
          </div>
        </template>
      </af-table-column>
      <af-table-column width="200" prop="serviceFees" :label="$t('siteMonitor.serviceCharge2')">
        <template slot-scope="scope">
          <div v-if="scope.row.typeCode === 'standard'">
            <span style="color: #2fff00;" class="span_one">{{ $t('key') }}</span><span
            v-html="$t('chang-gui-fu-wu-fei')+' : ' + scope.row.standardServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span>
          </div>
          <div v-else-if="scope.row.typeCode === 'times'">
            <span style="color: #ff4d4d;" class="span_one">{{ $t('key') }}</span><span
            v-html="(scope.row.pileType == 'Q'?$t('jian-fu-wu-fei')+' : ':$t('di-yi-jie-duan-fu-fu-fei')) + scope.row.topServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
            <span style="color:  #ffbc2e" class="span_one">{{ $t('key') }}</span><span
            v-html="(scope.row.pileType == 'Q'?$t('feng-fu-wu-fei')+' : ':$t('di-er-jie-duan-fu-fu-fei')) + scope.row.summitServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
            <span style="color: #43c26e" class="span_one">{{ $t('key') }}</span><span
            v-html="(scope.row.pileType == 'Q'?$t('ping-fu-wu-fei')+' : ':$t('di-san-jie-duan-fu-fu-fei')) + scope.row.flatServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
            <span style="color: #409EFF" class="span_one">{{ $t('key') }}</span><span
            v-html="(scope.row.pileType == 'Q'?$t('gu-fu-wu-fei')+' : ':$t('wang-hou-jie-duan-fu-fu-fei')) + scope.row.valleyServiceFees +  (scope.row.pileType == 'Q'?$t('yuan-kw'):$t('yuan-fen-zhong'))"></span><br/>
          </div>
        </template>
      </af-table-column>
      <af-table-column prop="discountRate" :label="$t('zhe-kou-shuai')"></af-table-column>
      <af-table-column prop="electricLossRate" :label="$t('dian-sun-bi-shuai')"></af-table-column>
      <af-table-column :label="$t('cao-zuo-qu-fen')">
        <template slot-scope="scope">
          <el-tag v-show="scope.row.operationType === 'U'">{{ $t('alaramMonitor.edit') }}</el-tag>
          <el-tag v-show="scope.row.operationType === 'D'" type="danger">{{ $t('deviceControl.delete') }}</el-tag>
        </template>
      </af-table-column>
      <af-table-column prop="updateDate" :label="$t('zui-hou-geng-xin-shi-jian')"></af-table-column>
    </el-table>

    <!-- 分页组件 -->
    <PaginationHis v-bind:child-msg="pagehisparam" @callFather="changeHisPage"></PaginationHis>

  </div>
</template>

<script>
  import rateApi from "../../api/rateApi";
  import PaginationHis from "../../../../components/Pagination";

  export default {
    name: "hislist",
    data(){
      return{
        showHisFilters: true,
        //历史费率数据 查询
        searchHisLoading: false,
        searchHisForm: {},
        showHisFilters: true,
        rateHisDataTable:[{}],
        listHisLoading:false,
        operatorTree:[],
        pagehisparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    props:{
      operatorHisList: ''
    },
    mounted() {
      this.submitSearchHisForm()
    },
    methods:{
      resetSearchHisttoryForm() {
        this.searchHisForm = {}
        this.submitSearchHisForm()
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchHisForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
     // 加载下拉框
      loadSelectItem() {
        rateApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorTree = res.data
          }
        })
      },
      submitSearchHisForm() {
        this.searchHisLoading = true
        this.listHisLoading = true
        //查询recordType等2的数据
        this.searchHisForm.recordType = 2
        this.pagehisparam.t = this.searchHisForm
        let param = Object.assign({}, this.pagehisparam)
        rateApi.getHisRates(param).then((res) => {
          if (res.code === 0) {
            this.pagehisparam.total = res.data.total
            this.rateHisDataTable = res.data.records
          } else {

          }
          this.searchHisLoading = false
          this.listHisLoading = false
        })
      },
      changeHisPage() {
        this.submitSearchHisForm()
      }
    },
    created: function () {
      this.loadSelectItem()
    },
    components:{
      PaginationHis
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/hislist.vue